import { Component, OnInit } from '@angular/core';
import {
  ContactcCenterMwHeraldService,
  PingResponse,
  VersionResponse,
} from '@common/services/utility/contactcentermwherald.service';
import { VersionService } from '@common/services/utility/version.service';
import { FeatureSupportService } from '@common/services/feature-support/feature-support.service';

class ComponentStatus {
  public Name: string;
  public PingResponse: PingResponse;
  public VersionResponse: VersionResponse;
}

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
})
export class StatusComponent implements OnInit {
  public currentTime: string;
  public version: string;
  public statuses: ComponentStatus[];

  constructor(
    private readonly versionService: VersionService,
    private readonly contactCenterMwHeraldService: ContactcCenterMwHeraldService,
    private readonly featureSupportService: FeatureSupportService,
  ) {}

  async ngOnInit(): Promise<void> {
    const components = ['taskrouting', 'configuration'];

    if (this.featureSupportService.isFeaturesEnabled('videochat')) {
      components.push('videochat');
    }

    if (this.featureSupportService.isFeaturesEnabled('livechat')) {
      components.push('livechat');
    }

    this.statuses = await this.checkComponents(components);

    const today = new Date();
    const date = `${today.getUTCFullYear()}-${this.timeToString(today.getUTCMonth() + 1)}-${this.timeToString(
      today.getUTCDate(),
    )}`;
    const time = `${this.timeToString(today.getUTCHours())}:${this.timeToString(
      today.getUTCMinutes(),
    )}:${this.timeToString(today.getUTCSeconds())}`;
    this.currentTime = `${date} ${time} GMT+00:00`;

    this.version = this.versionService.version;
  }

  private async checkComponents(components: string[]): Promise<ComponentStatus[]> {
    const results: ComponentStatus[] = [];

    for (const index in components) {
      let versionResponse: VersionResponse = { Version: '-1' };
      const component = components[index];
      try {
        versionResponse = await this.contactCenterMwHeraldService.version(component);
      } catch (error) {
        console.error(error.message);
      }

      let pingResponse: PingResponse = { Pong: 'NOT' };

      try {
        pingResponse = await this.contactCenterMwHeraldService.ping(component);
      } catch (error) {
        console.error(error.message);
      }

      const status: ComponentStatus = {
        Name: component,
        PingResponse: pingResponse,
        VersionResponse: versionResponse,
      };
      results.push(status);
    }

    return results;
  }

  private timeToString(time: number): string {
    if (time <= 9) {
      return `0${time}`;
    } else {
      return time.toString();
    }
  }
}
